import React, { useState, useEffect } from 'react';

import { Button, Box, Grid, Modal } from '@material-ui/core';
import Select, { components } from 'react-select';

import { CircularProgress } from '@material-ui/core';
import { toast } from '@jumbo/components/custom/Toast';
import { Delete } from '@material-ui/icons';
import { updateUserWithNetwork } from 'services/api';

const UpdateApps = props => {
  const { openDialog = false, close, submit, userUpdate, aplicaciones /* organization */ } = props;

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '40%',
    minHeight: 350,
    minWidth: 350,
    bgcolor: 'background.paper',
    borderRadius: 5,
    boxShadow: 24,
    p: 4,
  };

  const [loading, setLoading] = useState(false);

  /* datos aplicaciones roles */
  /* 
    const [aplicaciones, setAplicaciones] = useState([]); */
  const [roles, setRoles] = useState([]);
  /*   const [rolesDisabled, setRolesDisabled] = useState(true); */
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [rolesSelected, setRolesSelected] = useState([]);
  const [dropDownOptionsRoles, setDropDownOptionsRoles] = useState([]);
  const [dropAplicacionMasRoles, setDropDownAplicacionMasRoles] = useState('')

  useEffect(() => {
    if (userUpdate !== null) {
      let aux = [];
      userUpdate.roles_user.map(rol => {
        aux.push({
          app: { value: rol.application.id, label: rol.application.name },
          rol: { value: rol.id, label: rol.name },
        });
        return null;
      });
      console.log('userupdate', userUpdate)
      console.log('aux', aux)
      setRoles(aux);
    }
  }, [userUpdate]);

  useEffect(() => {
    if (aplicaciones.length) {
      let aux_app_con_rol = []
      aplicaciones.map(app => {
        app.roles.map(rol => {
          let obj_completo = {
            label: app.name + ' - ' + rol.name,
            value: app.id + "" + rol.id,
            valorAgregar: {
              app: {
                value: app.id,
                label: app.name
              },
              rol: {
                value: rol.id,
                label: rol.name
              }
            }
          }
          aux_app_con_rol.push(obj_completo)
        })
      })

      setDropDownAplicacionMasRoles(aux_app_con_rol)
    }
    // eslint-disable-next-line
  }, [aplicaciones]);

  const NoOptionsMessage = props => {
    return (
      <components.NoOptionsMessage {...props}>
        <span>No hay mas opciones</span>
      </components.NoOptionsMessage>
    );
  };

  const onCloseDialog = event => {
    if (loading) {
      event.preventDefault();
      return;
    }

    setLoading(false);

    setRoles([]);

    close();
  };

  const postRoles = () => {
    var auxRoles = [];
    auxRoles = roles.map(item => {
      return item.rol.value;
    });
    /*     if (userUpdate.roles_user.length) {
          if (validacionRol(SADMIN, userUpdate)) {
            auxRoles.push(userUpdate.roles_user.find(e => e.name === SADMIN).id);
          }
          if (validacionRol(ADMIN, userUpdate)) {
            auxRoles.push(userUpdate.roles_user.find(e => e.name === ADMIN).id);
          }
        } */
    return auxRoles;
  };

  const validate = () => {
    var res = true;
    if (roles.length === 0) {
      /*  setRolesError('Debe agregar al menos un rol'); */
      res = false;
    }

    return res;
  };

  const isActiveToBoolean = num => {
    if (num === 1) {
      return true;
    } else {
      return false;
    }
  };

  const onSubmitClick = () => {
    setLoading(true);
    /*     if (!validate()) {
          setLoading(false);
          return;
        } */

    /* 
    
        const logateUser = JSON.parse(sessionStorage.getItem('user'));
        var auxUser = {};
    
        auxUser.id = userUpdate.id;
        auxUser.run = userUpdate.run;
        auxUser.dv = userUpdate.dv;
        auxUser.names = userUpdate.names;
        auxUser.last_name = userUpdate.last_name;
        auxUser.email = userUpdate.email;
        auxUser.organization_id = logateUser.organization_id;
        auxUser.roles_user = postRoles();
        auxUser.mother_last_name = userUpdate.motherLastName;
        auxUser.is_active = isActiveToBoolean(userUpdate.is_active);
        auxUser.type_user = 'CU';
    
        axios
          .put(`${API_AUTH}user/${userUpdate.id}`, auxUser, {
            headers: { Authorization: `Bearer ${logateUser.token}` },
          })
          .then(res => {
            toast.success('Usuario modificado correctamente.');
            setLoading(false);
            onCloseDialog();
            submit();
          })
          .catch(err => {
            toast.error('Error al modificar usuario.');
            setLoading(false);
          });
    
    */

    var auxUser = {};
    auxUser.id = userUpdate.id;
    auxUser.run = userUpdate.run;
    auxUser.dv = userUpdate.dv;
    auxUser.names = userUpdate.names;
    auxUser.last_name = userUpdate.last_name;
    auxUser.email = userUpdate.email;
    auxUser.is_network = userUpdate.is_network
    auxUser.organization_id = userUpdate.organization_id;
    auxUser.organization = userUpdate.organization
    auxUser.roles_user = postRoles();
    if (userUpdate.is_network) {
      auxUser.user_organizations = userUpdate.user_organizations
    } else {
      auxUser.user_organizations = []
    }
    if (userUpdate.mother_last_name) {
      auxUser.mother_last_name = userUpdate.mother_last_name;
    }
    auxUser.is_active = isActiveToBoolean(userUpdate.is_active);
    auxUser.type_user = 'CU';

    updateUserWithNetwork(userUpdate.id, auxUser)
      .then(res => {
        toast.success('Usuario modificado correctamente.');
        onCloseDialog();
        submit();
      })
      .catch(err => {
        toast.error('Error al modificar usuario.');
      })
      .finally(f => {
        setLoading(false)
      })

  };

  const handleChangeRol = evt => {
    let aux = [];
    evt.map((item, index) => {
      aux.push(item);
      return null;
    });
    setRolesSelected(aux);
  };

  const handleChangeAplicacion = evt => {
    if (evt === null) {
      setRolesSelected([]);
      setSelectedApplication(evt);
    } else {
      let aux = [];
      aplicaciones.map((item, index) => {
        if (item.id === evt.value) {
          aux = item.roles;
        }
        return null;
      });
      let aux2 = [];
      /*  aux2.push({ value: 2, label: 'Administrador' }); */
      aux.map((item, index) => {
        let obg = {
          value: item.id,
          label: item.name,
        };
        aux2.push(obg);
        return null;
      });
      setDropDownOptionsRoles(aux2);
      setSelectedApplication(evt);
    }
  };

  const dropDownOptionsAplicaciones = [];
  /* const dropDownOptionsAplicaciones = [{ value: '1', label: 'Seguimiento de reclamos' }]; */
  aplicaciones.map((item, index) => {
    let auxItem = {
      value: item.id,
      label: item.name,
    };
    dropDownOptionsAplicaciones.push(auxItem);
    return null;
  });

  const removeRol = (appLabel, rolLabel) => {
    setRoles(roles.filter(item => !(item.app.label === appLabel && item.rol.label === rolLabel)));
  };

  const getAplicacionesConRoles = () => {

    return roles.map((item, index) => {
      return (
        <div key={index}>
          {index === 0 ? <hr /> : null}
          <Grid container spacing={0} key={index} style={{ marginTop: 5 }}>
            <Grid item xs={4} style={{ textAlign: 'center' }}>
              {item.app.label}
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'center' }}>
              {item.rol.label}
            </Grid>
            <Grid item xs={4} style={{ textAlign: 'end', color: 'red' }}>
              <Delete
                style={{ cursor: 'pointer' }}
                onClick={() => {
                  removeRol(item.app.label, item.rol.label);
                }}
              />
            </Grid>
          </Grid>
          <hr />
        </div>
      );
    });
  };

  const isRolesDisabled = () => {
    if (selectedApplication === null) {
      return true;
    } else {
      return false;
    }
  };

  const isInArray = elem => {
    let aux = false;

    roles.map((item, index) => {
      if (item.app.label === elem.app.label && item.rol.label === elem.rol.label) {
        aux = true;
      }
      return null;
    });

    return aux;
  };

  const agregarRolesPorApp = () => {
    if (selectedApplication !== null) {
      if (rolesSelected.length > 0) {
        /* aca el setRoles */
        let aux = [];

        roles.map((item, index) => {
          aux.push(item);
          return null;
        });

        rolesSelected.map((item, index) => {
          let objApp = {
            app: selectedApplication,
            rol: item,
          };

          if (!isInArray(objApp)) {
            aux.push(objApp);
          } else {
            toast.error('Ese rol ya está en la lista');
          }

          return null;
        });

        setRoles(aux);
        setSelectedApplication(null); //devuelve el select de aplicacion a "seleccione aplicacion"
        setRolesSelected([]); //devuelve el select a "seleccione rol"
      } else {
        toast.error('Debe seleccionar al menos un rol');
      }
    } else {
      toast.error('Debe seleccionar una aplicacion');
    }
  };

  const msgStyles = {
    color: "red"
  };

  return (
    <Modal open={openDialog} onClose={onCloseDialog}>
      <Box sx={style} flexDirection="column" justifyContent="space-between">
        <div>
          <h2 style={{ marginBottom: 5 }}>
            Actualizar Aplicaciones de usuario {userUpdate !== null ? userUpdate.nombre_completo : null}
          </h2>

          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={0}>
              {/*               <Grid item xs={5}>
                <Select
                  placeholder="Seleccione Aplicación"
                  options={dropDownOptionsAplicaciones}
                  onChange={handleChangeAplicacion}
                  value={selectedApplication}
                  isClearable={true}
                />
              </Grid>
              <Grid item xs={5}>
                <Select
                  placeholder="Seleccione Rol"
                  options={dropDownOptionsRoles}
                  onChange={handleChangeRol}
                  isDisabled={isRolesDisabled()}
                  isMulti={true}
                  value={rolesSelected}
                />
              </Grid>
              <Grid item xs={2} style={{ textAlign: 'center' }}>
                <Button variant="outlined" color="primary" onClick={agregarRolesPorApp}>
                  Agregar
                </Button>
              </Grid> */}
              <Grid item xs={12}>
                <Select
                  placeholder="Seleccione Aplicación y rol para el usuario"
                  options={dropAplicacionMasRoles}
                  onChange={(e) => {
                    setRoles(prev => {
                      const exists = prev.some(
                        r =>
                          r.app.value === e.valorAgregar.app.value &&
                          r.rol.value === e.valorAgregar.rol.value
                      );

                      if (exists) return prev;

                      return [...prev, e.valorAgregar];
                    });
                  }}
                  value={rolesSelected}
                  components={{ NoOptionsMessage }}
                  styles={{ noOptionsMessage: base => ({ ...base, ...msgStyles }) }}
                />
              </Grid>
            </Grid>
          </Box>
          <Box sx={{ flexGrow: 1 }}>{getAplicacionesConRoles()}</Box>
        </div>
        <Box display="flex" justifyContent="flex-end" style={{ position: 'absolute', bottom: 0, right: 16 }} mb={4}>
          <Button onClick={onCloseDialog} disabled={loading}>
            Cancelar
          </Button>

          <Box ml={2}>
            <Button variant="outlined" color="primary" onClick={onSubmitClick} disabled={loading}>
              {loading ? <CircularProgress color="inherit" style={{ height: '22px', width: '22px' }} /> : 'Modificar'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default UpdateApps;
